import { AutoCompleteItem } from "../autocomplete/interface";
import {
  TicketHeading,
  TicketRoot,
  TicketSub,
  TicketSubItem,
} from "../ticket/Ticket";

function FormControlButton<T>(props: {
  remove: () => void;
  selectedItem: AutoCompleteItem<T>;
  disabled?: boolean;
  shouldFocusOnMount?: boolean;
}) {
  const { remove, selectedItem, disabled, shouldFocusOnMount } = props;
  return (
    <TicketRoot
      button
      icon={disabled ? undefined : "close"}
      className={`form-control${disabled ? " c-ticket-disabled" : ""}`}
      onClick={() => {
        if (!disabled) remove();
      }}
      focusOnMount={shouldFocusOnMount}
    >
      <TicketHeading>
        <h4 className="h5">{selectedItem.header}</h4>
      </TicketHeading>
      <TicketSub>
        <TicketSubItem>{selectedItem.subheader}</TicketSubItem>
      </TicketSub>
    </TicketRoot>
  );
}

export default FormControlButton;
